export default __webpack_public_path__ + "static/superbright-7a1a21793ffe886556f77df907d4feb6.jpg";